const getters = {
    getServiceList(state) {
        return state.serviceList;
    },
    getService(state) {
        return state.service;
    }
}

export default getters;